module.exports = __webpack_public_path__ + "img/logo_with_tm.ea88b125.png";